var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneFlat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8381",
    "data-name": "Group 8381",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.175,
    height: 10.592,
    viewBox: "0 0 11.175 10.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 11.175,
    height: 10.592,
    fill: "#05ce78"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8380",
    "data-name": "Group 8380",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M11.175,5.471c-.041.075-.079.152-.123.225a.826.826,0,0,1-.735.434c-1.018,0-2.037,0-3.057,0Q6.5,7.346,5.733,8.563q-.617.984-1.233,1.969c-.016.026-.049.058-.075.058-.352,0-.7,0-1.078,0l1.4-4.461H4.615q-1.44,0-2.881,0a.143.143,0,0,0-.1.05c-.256.333-.507.67-.763,1a.179.179,0,0,1-.12.061c-.25.008-.5.008-.752.01V7.214l.02-.024a.656.656,0,0,1,.013-.084C.188,6.569.346,6.033.5,5.5a.512.512,0,0,0,.039-.246C.426,4.828.3,4.411.176,3.991.12,3.8.071,3.6.02,3.4L0,3.38V3.336c.247,0,.494.006.741.007a.151.151,0,0,1,.141.07c.248.339.5.672.759,1a.118.118,0,0,0,.081.042q1.462,0,2.924,0c.028,0,.056,0,.1-.005L3.347,0c.371,0,.723,0,1.075,0A.105.105,0,0,1,4.494.05q1,1.6,2,3.192c.253.4.51.808.77,1.22h3a.883.883,0,0,1,.817.468c.039.068.067.143.1.215Z",
    transform: "translate(0 -0.001)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M.02,123.88a.056.056,0,0,0-.02,0v-.022l.02.024",
    transform: "translate(0 -120.477)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M0,263.5a.056.056,0,0,0,.019,0L0,263.518V263.5",
    transform: "translate(0 -256.305)",
    fill: "#05ce78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneFlat);
export default __webpack_public_path__ + "static/media/plane-flat.6f6edfda8aefb769bad70fa277a62d5d.svg";
export { ForwardRef as ReactComponent };